export function setBrandQuery() {
    const paginationButton = document.querySelector('.__endless_pagination__button[data-brand]');
    if(!paginationButton) return;
    const reloadedPageHref = new URL(window.location.href);
    reloadedPageHref.searchParams.set('brand', paginationButton.dataset.brand);
    history.replaceState({}, '', reloadedPageHref.search.toString());
}